module.exports = __webpack_public_path__ + "img/LIVEPEN.a00eb6b8.png";